export default __webpack_public_path__ + "static/media/category.6aa0852e.jfif";